import {EventEmitter, Injectable} from '@angular/core';

@Injectable()
export class UserRegulationsService {

  showUserRegulations: EventEmitter<boolean> =  new EventEmitter<boolean>();

  constructor() { }

  showUserRegulationsPopup() {
    this.showUserRegulations.emit(true);
  }

}
